<template>
  <table class="total-table">
    <tbody>
      <tr>
        <th class="total-table--header">{{$t('headers.diagnosticTypesTotal')}}</th>
        <td class="total-table--row"><em>{{getTotalOfTypes('diagnosticTypes')}}</em></td>
      </tr>
      <tr>
        <th class="total-table--header">{{$t('headers.repairTypesTotal')}}</th>
        <td class="total-table--row"><em>{{getTotalOfTypes('repairTypes')}}</em></td>
      </tr>
      <tr>
        <th class="total-table--header">{{$t('headers.partsUsedTotal')}}</th>
        <td class="total-table--row"><em>{{getTotalOfTypes('partsTypes')}}</em></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { getTotalOfTypes } from "@/services/partsPreviewService"
export default {
  props: {
    parts: {
      type: Array,
      required: true
    }
  },
  methods: {
    getTotalOfTypes(prop) {
      return getTotalOfTypes(prop, this.parts, c => this.$t(c))
    }
  }
}
</script>

<style scoped>
table.total-table {
  max-width: 37rem;
}

table.total-table > tbody > tr > td.total-table--row {
  color: #464646;
  font-family: 'Titillium Web', sans-serif;
  font-weight: 400;
  font-size: 0.9rem;
  letter-spacing: 1px;
  background-color: rgba(0, 0, 0, 0.02);
  border-left: white 1px solid !important;
  border-right: white 1px solid !important;
  border-top: 1px solid #dee2e6 !important;
}

table.total-table > tbody > tr > .total-table--header {
  border-left: white 1px solid;
  border-right: white 1px solid;
  background-color: #cfd8dc !important;
  height: 2.3rem;
  width: 12rem;

  color: #000000;
  font-family: 'Titillium Web', sans-serif;
  font-weight: 300;
  font-size: 0.9rem;
  letter-spacing: 1px;
}
table.total-table > tbody > tr > td, th {
  padding: 0px 16px;
  text-align: start;
}
</style>